import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

import { firebaseConfig } from './xross.config.js';

console.log('firebaseConfig:', firebaseConfig);

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const timestamp = firebase.firestore.FieldValue.serverTimestamp();
// クライアントタイムスタンプ（UI用や仮置き用）
export const nowTimestamp = () => firebase.firestore.Timestamp.now();

export const provider = new firebase.auth.GoogleAuthProvider();

/* ============================================================
   Firebase Functions（共通化）
============================================================ */

// 🔥 region あり/なしに合わせて選択
const functions = firebase.app().functions('asia-northeast1');

// 友達UIDリスト Callable（共通利用用）
export const getFriendUIDListFn = functions.httpsCallable('getFriendUIDList');
